import TestimonialsSVG from "@/public/icons/Testimonials.svg";
import TestimonialsBgSVG from "@/public/icons/testimonials-bg.svg";
import Link from "next/link";
import routes from "@/constants/routes";

const Testimonials = (): JSX.Element => {
  return (
    <section className="flex flex-col md:flex-row w-col mx-4 md:flex-col md:mt-12 xl:mt-16 items-center">
      <div className="max-w-full lg:w-[70rem] md:w-full">
        <div className="flex flex-col md:flex-row justify-between">
          <h3 className="flex md:hidden text-4xl lg:text-5xl font-bold text-landing-blue self-center mb-5 md:mb-3 lg:mb-5">
            Customer stories
          </h3>
          <div className="flex flex-col  w-auto md:w-1/2">
            <div className="relative flex w-full my-auto ml-auto mr-2  md:ml-0 md:h-2/4 lg:h-fit max-w-[340px] md:max-w-[486px]">
              <div className="absolute left-0 max-w-full bottom-0 z-0 ">
                <TestimonialsBgSVG />
              </div>
              <div className="z-10 flex flex-col top-0 left-0 items-start w-11/12 pb-20 item">
                <div className="w-full">
                  <TestimonialsSVG className="w-full " />
                  <span className="text-xs">
                    * Stock images used to protect the privacy of our customers
                  </span>
                </div>
              </div>
            </div>
            <h3 className="hidden md:flex text-4xl lg:text-5xl font-bold text-landing-blue my-5 md:mb-3 lg:mb-5">
              Customer stories
            </h3>
            <div className="flex flex-col md:flex-row lg:flex-col items-center">
              <div className="w-full">
                <h4 className="font-serif text-3xl text-landing-blue mb-2">
                  Steve, 29 & Ashna, 30
                </h4>
                <h4 className="text-xl font-bold mb-4">First time buyers</h4>
                <p className="font-base mb-5">
                  We really liked how simple and effective the whole process was. At first we
                  thought the offer was too good to be true - but the fact that it was so easy to
                  communicate with everyone in the team made it so seamless because we could pick up
                  the phone or email anyone if we had any issues or concerns.
                </p>
                <p className="font-base mb-5">
                  It was really special moving into our new home. It felt really surreal because we
                  didn’t have to do any of the conveyancing and had no direct contact with the
                  people in the transition process apart from the estate agent. Because we didn’t
                  have any contact other than just getting the keys.
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col max-w-auto md:max-w-[340px] lg:max-w-[486px] w-auto md:w-1/2">
            <p className="font-base mb-5">
              We know the work involved to get it over the line, so it felt amazing to walk into our
              house at the end of the process. We’ve put in new carpets, new floors, painting the
              walls. it’s become a home already.
            </p>
            <p className="font-base mb-5">
              We explored going with a traditional mortgage but with Keyzy we can keep cash in the
              bank rather than put deposit down which we could use to add value. We viewed it as
              100% LTV mortgage which would have cost more.
            </p>
            <p className="font-base mb-5">
              Negotiation of the price can be quite big because Keyzy does this day-in, day-out. It
              also comes in quite handy that Keyzy does Open Banking rather than payslips to verify
              income. It was a big win for us because I only had 1 year of accounts to show. It was
              really straightforward.
            </p>
            <p className="font-base mb-5">
              When you’re renting you have limited control. Our old flat had carpets from 1970! So
              we actually have our own place to make our own. Also it’s dead money when you’re
              renting - it goes out every month. This way your renting becomes an asset, you’re kind
              of investing.
            </p>
            <p className="font-base mb-5">
              We’ve done cosmetic stuff and some electrical improvements. We’re considering ripping
              the garage at the back or doing an extension, but we’re not sure yet if it’ll add the
              value that we expect. But we came into this thinking of doing a ground floor
              extension.
            </p>
            <div className="self-start flex flex-row w-full">
              <Link href={routes.register}>
                <a className="flex md:hidden lg:flex w-full self-start items-center justify-center h-10 px-14 py-3 mt-4 text-base font-bold transition duration-300 ease-in-out transform rounded-md whitespace-nowrap text-white md:mt-0 md:w-auto bg-landing-orange hover:scale-105">
                  Apply now
                </a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
